import React, { useState, useEffect } from "react";
import Select from "react-select";
import "../../assets/css/style.css"
import "../../assets/css/tailwind.css"
import "../../assets/css/responsive.css"
import "../../assets/css/demo-1.css"
import "../../assets/css/vendor/gicons.css";
import "../../assets/css/vendor/gicons.css";
import "../../assets/css/plugins/animate.css";
import "../../assets/css/plugins/nouislider.css";
import "../../assets/css/plugins/owl.carousel.min.css";
import "../../assets/css/plugins/owl.theme.default.min.css";
import "../../assets/css/plugins/slick.min.css";
import "../../assets/css/plugins/swiper-bundle.min.css";
import Footer from '../../components/common/footer/Footer'
import Common_Images_Transport from "../../components/common/common_imges_transport/Common_Images_Transport";
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import { AstroRegister } from "../../api/auth_api/Astro_Auth";
import { isValidFullName, isValidEmail } from "../../components/validation/Validation";
import { toast } from 'react-toastify'
import { User_Otp_Verify } from "../../api/auth_api/Auth_Api";
import OtpInput from "react-otp-input";
import Loader from "../../loader/Loader";
import { useNavigate } from "react-router-dom";
import Astrologer_Header from "../../components/pages/astrologer/astrologer_header/Astrologer_Header";
import { get_language_and_skills, handle_get_pooja_list_category } from "../../api/astrologer/Astrologer";
import { Link } from "react-router-dom"
import { get_Page_Seo } from "../../api/global/Global";
import { Helmet } from "react-helmet";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../config/Config";

const Astrologer_Register = () => {
    const navigate = useNavigate()
    const [pageSeo, set_Page_Seo] = useState({})

    const OTP_TIMEOUT = 5 * 60; // 5 minutes in seconds
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(OTP_TIMEOUT);
    const [otpExpired, setOtpExpired] = useState(false);
    const [tempId, setTempId] = useState(null);
    const [otpAttempts, setOtpAttempts] = useState(0);
    const [cooldownTime, setCooldownTime] = useState(0);

    const roleBasedRoutes = {
        '2': "/astrologer-profile",
        '3': "/pandit-profile",
    };

    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('+91');
    const [mobileNumber, setMobileNumber] = useState('');
    const [countryCode, setCountryCode] = useState('IN');
    const [isValid, setIsValid] = useState(false);
    const [astrologer_skills, set_Astrologer_Skills] = useState([])
    const [astrologer_language, set_Astrologer_Language] = useState([])
    const [pandit_skills, set_Pandit_Skills] = useState([])
    const [pandit_language, set_Pandit_Language] = useState([])
    const [pooja_Categories, set_Pooja_Categories] = useState([])
    const [userLocation, setLocation] = useState(null);
    const [error, setError] = useState(null);

    const user_Roles = [
        { value: "2", label: "Astrologer" },
        { value: "3", label: "Pandit" },

    ];

    console.log("pandit_language", pandit_language)
    const [astro_register_form, set_Astro_Register_Form] = useState({
        name: "",
        user_name: "",
        email: "",
        country_code: "",
        mobile: "",
        gender: "",
        role: "",
        dob: "",
        profileImg: "",
        skills: [],
        language: [],
        poojacategorie: [],

    })
    console.log("skillsValues", astro_register_form?.skills);

    useEffect(() => {

        const getLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLocation({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                        //   fetchAstrologers(position.coords.latitude, position.coords.longitude);
                    },
                    (err) => setError(err.message)
                );
            } else {
                setError("Geolocation is not supported by this browser.");
            }
        };
        getLocation();
    }, []);

    // <-------------- OTP session timeout --------------->
    useEffect(() => {
        if (showOtpScreen) {
            if (otpTimer <= 0) {
                setOtpExpired(true);
                return;
            }
            const countdown = setInterval(() => {
                setOtpTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(countdown);
        }
    }, [otpTimer, showOtpScreen]);

    // <-------------- OTP attempts and cooldown initialization & countdown --------------->
    useEffect(() => {
        if (mobileNumber) {
            const savedAttempts = localStorage.getItem(`otp_attempts_${mobileNumber}`);
            if (savedAttempts) {
                setOtpAttempts(parseInt(savedAttempts, 10));
            } else {
                setOtpAttempts(0);
            }

            const cooldownUntil = localStorage.getItem(`otp_cooldown_until_${mobileNumber}`);
            if (cooldownUntil) {
                const remaining = Math.ceil((parseInt(cooldownUntil, 10) - Date.now()) / 1000);
                if (remaining > 0) {
                    setCooldownTime(remaining);
                } else {
                    setCooldownTime(0);
                    localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                    localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                    setOtpAttempts(0);
                }
            } else {
                setCooldownTime(0);
            }
        }
    }, [mobileNumber, showOtpScreen]);

    useEffect(() => {
        if (cooldownTime > 0) {
            const timer = setInterval(() => {
                setCooldownTime(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                        localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                        setOtpAttempts(0);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [cooldownTime, mobileNumber]);

    const formatTimer = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    const formatMobileNumber = (mobile) => {
        if (!mobile || mobile.length < 10) return mobile;
        const firstTwoDigits = mobile.slice(0, 2);
        const lastTwoDigits = mobile.slice(-2);
        return `${firstTwoDigits}******${lastTwoDigits}`;
    };

    const HandleResendOtp = async () => {
        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }
        setIsLoading(true);
        const normalizedName = astro_register_form?.name?.trim() || "";
        const normalizedEmail = astro_register_form?.email?.trim().toLowerCase() || "";

        const formData = new FormData();
        formData.append('user_role', astro_register_form.role);
        formData.append('name', normalizedName);
        formData.append('user_name', astro_register_form.user_name);
        formData.append('dob', astro_register_form?.dob);
        formData.append('gender', astro_register_form?.gender);
        formData.append('email', normalizedEmail);
        formData.append('experience', astro_register_form?.experience);
        formData.append('mobile', mobileNumber);
        formData.append('country_code', `+${countryCode}`);

        if (astro_register_form?.profileImg) {
            formData.append('profileImg', astro_register_form?.profileImg);
        }

        const languageValues = astro_register_form?.language?.map(item => item.value).join(',');
        const skillsValues = astro_register_form?.skills?.map(item => item.value).join(',');
        const categoryValues = astro_register_form?.poojacategorie?.map(item => item.title).join(',');

        formData.append('latitude', userLocation?.lat || "");
        formData.append('longitude', userLocation?.lng || "");

        formData.append('language', languageValues);
        formData.append('skills', skillsValues);
        formData.append('pooja', categoryValues);

        try {
            const response = await AstroRegister(formData);
            if (response?.data?.status == "200") {
                setIsLoading(false);
                setTempId(response?.data?.data?.user?.id);
                setOtpTimer(OTP_TIMEOUT);
                setOtpExpired(false);
                setOtp('');
                toast("OTP resent successfully");
            } else {
                setIsLoading(false);
                toast(response?.response?.data?.message || "Error resending OTP");
            }
        } catch (error) {
            setIsLoading(false);
            console.log("error", error);
        }
    };

    const Handle_Astrologer_Register_Otp_Verify = async (e) => {
        e.preventDefault();

        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }

        if (otpExpired) {
            toast("OTP session expired. Please request a new OTP.");
            setShowOtpScreen(false);
            return;
        }
        setIsLoading(true);

        if (otp.length !== 4) {
            setOtpError(true);
            setIsLoading(false);
            toast("Please enter a valid 4-digit OTP.");
            return;
        }

        const otp_verify_data = {
            otp,
            type: "register",
            country_code: `+${countryCode}`,
            mobile: mobileNumber,
            device_type: "web",
            temp_id: tempId,
        };
        try {
            const response = await User_Otp_Verify(otp_verify_data);
            let user_role = response?.data?.data?.user?.user_role;
            if (response?.data?.status == "200") {
                setIsLoading(false);
                toast(response?.data?.message);
                if (mobileNumber) {
                    localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                    localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                }
                localStorage.setItem("user_token", response?.data?.data?.token);
                localStorage.setItem("user_role", response?.data?.data?.user?.user_role);
                const path = roleBasedRoutes[user_role?.toString()];
                navigate(path);
            } else {
                setIsLoading(false);
                toast(response?.response?.data?.message || "Invalid OTP");

                if (mobileNumber) {
                    const newAttempts = otpAttempts + 1;
                    setOtpAttempts(newAttempts);
                    localStorage.setItem(`otp_attempts_${mobileNumber}`, newAttempts);

                    if (newAttempts >= 3) {
                        localStorage.setItem(`otp_cooldown_until_${mobileNumber}`, Date.now() + 5 * 60 * 1000);
                        setCooldownTime(300);
                        toast("Too many attempts. please try again later");
                    }
                }
            }
        } catch (error) {
            setIsLoading(false);

            if (mobileNumber) {
                const newAttempts = otpAttempts + 1;
                setOtpAttempts(newAttempts);
                localStorage.setItem(`otp_attempts_${mobileNumber}`, newAttempts);

                if (newAttempts >= 3) {
                    localStorage.setItem(`otp_cooldown_until_${mobileNumber}`, Date.now() + 5 * 60 * 1000);
                    setCooldownTime(300);
                    toast("Too many attempts. please try again later");
                }
            }
        }
    };

    useEffect(() => {
        const Get_Page_Seo = async () => {
            setIsLoading(true);
            try {
                const response = await get_Page_Seo()
                console.log("PageSeo:", response);
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Astro/Pandit Registration"
                    )
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false);
            }
        }

        Get_Page_Seo()
    }, [])
    // <----------- Get the Master Data for the Astrologer Register Form -------------->


    useEffect(() => {
        const handle_get_master_data = async () => {
            try {
                const response = await handle_get_pooja_list_category();

                console.log("puja category", response?.data);
                if (response?.data?.status == 200) {
                    const pooja_Category = response?.data?.data?.pooja_category || []
                    const skills = response?.data?.data?.skills || []
                    const languages = response?.data?.data?.languages || []
                    console.log("pooja_Category", pooja_Category);

                    const astroSkills = skills
                        .filter(item => item.type === "astro")


                    const panditSkills = skills
                        .filter(item => item.type === "pandit")


                    const astroLanguages = languages
                        .filter(item => item.type === "astro")


                    const panditLanguages = languages
                        .filter(item => item.type === "pandit")

                    console.log("astroLanguages", astroLanguages);

                    // Convert skills into { value, label } format
                    const formattedastrolanguages = astroLanguages?.map(language => ({
                        value: language?.language,  // Assuming skills have an 'id' field
                        label: language?.language // Assuming skills have a 'name' field
                    }));
                    // Convert skills into { value, label } format
                    const formattedastroSkills = astroSkills?.map(skill => ({
                        value: skill.skill,  // Assuming skills have an 'id' field
                        label: skill.skill // Assuming skills have a 'name' field
                    }));

                    // Convert skills into { value, label } format
                    const formattedpanditlanguages = panditLanguages?.map(language => ({
                        value: language?.language,  // Assuming skills have an 'id' field
                        label: language?.language // Assuming skills have a 'name' field
                    }));
                    const formattedpanditSkills = panditSkills?.map(skill => ({
                        value: skill.skill,  // Assuming skills have an 'id' field
                        label: skill.skill // Assuming skills have a 'name' field
                    }));

                    console.log("formattedpanditSkills", formattedpanditSkills);

                    set_Astrologer_Language(formattedastrolanguages);
                    set_Astrologer_Skills(formattedastroSkills);
                    set_Pandit_Skills(formattedpanditSkills);
                    set_Pandit_Language(formattedpanditlanguages);
                    set_Pooja_Categories(pooja_Category)

                }

            } catch (error) {
                console.error("Error fetching skills:", error);
            }
        };

        handle_get_master_data();
    }, [])
    // <----------- Onchnage Events on the Phone Input section's -------------->
    const handlePhoneChange = (value) => {
        if (!value || !value.startsWith('+')) {
            setPhoneNumber('+91');
            setCountryCode('91');
            setMobileNumber('');
            return;
        }
        setPhoneNumber(value);
        try {
            const parsedPhone = parsePhoneNumber(value);
            setCountryCode(parsedPhone.countryCallingCode);
            setMobileNumber(parsedPhone.nationalNumber);
        } catch (error) {
            setMobileNumber('');
        }
    };

    // <----------- Handle Key Down Events on the Phone Input section's -------------->
    const handleKeyDown = (e) => {
        // Prevent deleting the "+" or the country code
        if (
            (e.key === "Backspace" || e.key === "Delete") &&
            phoneNumber &&
            phoneNumber.length <= 3 // block when cursor is within "+91"
        ) {
            e.preventDefault();
        }
    };
    // <--------- astro register onchange events ----------->
    const handle_astro_register_form = (e, fieldName) => {

        if (e.target && e.target.type === "file") {
            const file = e.target.files[0];
            if (file) {
                const validTypes = ["image/jpeg", "image/png", "image/jpg"];
                const maxSize = 5 * 1024 * 1024; // 5 MB

                if (!validTypes.includes(file.type)) {
                    toast("Invalid file type. Please upload a JPEG or PNG image.");
                    return;
                }

                if (file.size > maxSize) {
                    toast("File size exceeds 5 MB. Please upload a smaller image.");
                    return;
                }

                const previewUrl = URL.createObjectURL(file);
                set_Astro_Register_Form({
                    ...astro_register_form,
                    [fieldName]: file,
                    profileImgPreview: previewUrl,
                });
            }
        } else if (Array.isArray(e)) {
            set_Astro_Register_Form({
                ...astro_register_form,
                [fieldName]: e,
            });
        } else if (e.target && e.target.name && e.target.value !== undefined) {
            const { name, value } = e.target;
            console.log("name:dob", name, "value:", value);

            if (name == "dob") {
                console.log("success:", name);

                const year = value.split("-")[0];
                if (year.length > 4) return; // Block input with more than 4 digit year
            }
            set_Astro_Register_Form({
                ...astro_register_form,
                [name]: value,
            });
        }
    };


    const handleRoleChange = (selectedOption) => {
        console.log("Selected role:", selectedOption);

        set_Astro_Register_Form((prev) => ({
            ...prev,
            role: selectedOption.value
        }));
    };


    const handleCheckboxChange = (e) => {
        setCheckboxChecked(e.target.checked);
    };

    const validateUsername = (user_name) => {
        // Only letters, numbers, and special symbols. No spaces. 3–20 chars long.
        const regex = /^[a-zA-Z0-9]{3,20}$/;
        return regex.test(user_name);
    };

    // <---------------- Handle Submit the Astrologer register ------->
    const Handle_Submit_astro_register = async (e) => {
        e.preventDefault();
        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }
        setIsLoading(true)
        console.log("astro_register_form:", astro_register_form.role);

        const normalizedName = astro_register_form?.name?.trim() || "";
        const normalizedEmail = astro_register_form?.email?.trim().toLowerCase() || "";

        const formData = new FormData();
        formData.append('user_role', astro_register_form.role);
        formData.append('name', normalizedName);
        formData.append('user_name', astro_register_form.user_name);
        formData.append('dob', astro_register_form?.dob);
        formData.append('gender', astro_register_form?.gender);
        formData.append('email', normalizedEmail);
        formData.append('experience', astro_register_form?.experience);
        formData.append('mobile', mobileNumber);
        formData.append('country_code', `+${countryCode}`);
        formData.append('profileImg', astro_register_form?.profileImg);

        // Convert the language and skills arrays to a comma-separated list of values
        const languageValues = astro_register_form?.language?.map(item => item.value).join(',');
        const skillsValues = astro_register_form?.skills?.map(item => item.value).join(',');
        const categoryValues = astro_register_form?.poojacategorie?.map(item => item.title).join(',');

        formData.append('latitude', userLocation?.lat || "");
        formData.append('longitude', userLocation?.lng || "");

        formData.append('language', languageValues);
        formData.append('skills', skillsValues);
        formData.append('pooja', categoryValues);

        console.log("categoryValues", skillsValues);

        // Validation logic
        if (!normalizedName || !isValidFullName(normalizedName)) {
            toast("Please enter a valid full name (letters and single spaces only).");
            setIsLoading(false)
            return;
        }
        if (astro_register_form?.user_name?.length < 3) {
            toast("Username must be at least 3 characters long");
            setIsLoading(false)
            return;
        }
        if (astro_register_form?.user_name?.length > 20) {
            toast("Username cannot be longer than 20 characters");
            setIsLoading(false)
            return;
        }


        if (!astro_register_form?.user_name || !validateUsername(astro_register_form?.user_name)) {
            toast("Username can only contain letters and numbers (no spaces or special symbols)");
            setIsLoading(false)
            return;
        }





        if (!normalizedEmail || !isValidEmail(normalizedEmail)) {
            toast("Please enter a valid email address.");
            setIsLoading(false)
            return;
        }
        if (!astro_register_form?.gender) {
            toast("Please select your gender.");
            setIsLoading(false)
            return;
        }
        if (!astro_register_form?.role) {
            toast("Please select your role.");
            setIsLoading(false)
            return;
        }
        if (!astro_register_form?.experience) {
            toast("please enter your experience.");
            setIsLoading(false)
            return;
        }
        if (astro_register_form?.language?.length === 0) {
            toast("At least one language is required.");
            setIsLoading(false)
            return;
        }
        if (astro_register_form?.skills?.length === 0) {
            toast("At least one skill is required.");
            setIsLoading(false)
            return;
        }
        if (astro_register_form?.role == "3") {
            if (astro_register_form?.poojacategorie?.length === 0) {
                toast("At least one category is required.");
                setIsLoading(false)
                return;
            }
        }
        if (!checkboxChecked) {
            alert("You must agree to the terms and conditions.");
            return;
        }
        if (!astro_register_form?.profileImg) {
            toast("please upload your profile image");
            setIsLoading(false)
            return;
        }

        if (!isValid) {
            toast("Please enter a valid phone number containing only numbers.");
            setIsLoading(false)
            return;
        }
        console.log("formData:", formData);

        try {
            const response = await AstroRegister(formData)
            console.log("s", response)
            if (response?.data?.status == "200") {
                setIsLoading(false)
                set_Astro_Register_Form({})
                setTempId(response?.data?.data?.user?.id)
                setShowOtpScreen(true);
                setOtpTimer(OTP_TIMEOUT);
                setOtpExpired(false);
                setOtp('');
            }
            else if (response?.response?.data?.status == "500") {
                setIsLoading(false)
                toast(response?.response?.data?.message)
            }
        } catch (error) {
            setIsLoading(false)

        }
    }
    console.log("register :", astro_register_form);

    // <-------- Apply for the Phone Number Validtion According to the Country and Country code here ----------->
    useEffect(() => {
        setIsValid(isValidPhoneNumber(phoneNumber));
    }, [phoneNumber]);

    useEffect(() => {
        return () => {
            if (astro_register_form?.profileImgPreview) {
                URL.revokeObjectURL(astro_register_form?.profileImgPreview);
            }
        };
    }, [astro_register_form?.profileImgPreview]);

    // <------- clear the local storage --------->
    useEffect(() => {
        const keysToKeep = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && (key.startsWith("otp_cooldown_") || key.startsWith("otp_attempts_"))) {
                keysToKeep.push({ key, value: localStorage.getItem(key) });
            }
        }
        localStorage.clear();
        keysToKeep.forEach(({ key, value }) => localStorage.setItem(key, value));
    }, []);




    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}astrologer-register`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}astrologer-register`} />

            </Helmet>
            <div>
                {/*  */}
                <Astrologer_Header />
                {/* <-------- ToastContainer ------------> */}
                {/* <ToastContainer style={{ marginTop: "120px" }} /> */}
                {/* <-------- Header section's --------> */}
                {
                    isLoading ? (
                        <Loader />
                    ) : (
                        <>
                            <section className='banner-section'>
                                <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                    <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                    } className='w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover' />


                                </div>
                            </section>
                            <section className="gi-register bg-[#F0F4F8] py-[40px] max-[767px]:py-[30px]">
                                <div
                                    className=" justify-between items-center mx-auto min-[1600px]:max-w-[1600px] min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">

                                    <div className="min-[1000px]:max-w-[800px] m-auto">
                                        <div className="gi-register-wrapper my-[0] mx-auto px-[12px] ">
                                            <div
                                                className="gi-register-container border-[1px] border-solid border-[#eee] p-[30px] text-left bg-[#fff] rounded-lg max-[575px]:p-[15px]">
                                                {!showOtpScreen ? (
                                                    <div className="gi-login-form">
                                                        <h2
                                                            className="gi-title mb-[0] text-xl font-semibold text-gray-900 text-center p-[0] capitalize">
                                                            Astrologer/Pandit Registration<span></span></h2>
                                                        <form action="#" method="post" className="flex flex-row flex-wrap px-4 mt-5 mx-[-15px]" onSubmit={Handle_Submit_astro_register}>
                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                <div className="iconflexd text-center relative mb-5">
                                                                    <div className="columns relative w-[200px] m-auto">
                                                                        <div className="circle">
                                                                            <img
                                                                                className="profile-pic object-cover position-top rounded-full w-[150px] h-[150px] m-auto"
                                                                                src={
                                                                                    astro_register_form.profileImgPreview || // Show preview URL
                                                                                    Common_Images_Transport?.user_logo // Default image
                                                                                }
                                                                                alt="user"
                                                                            />
                                                                        </div>
                                                                        <label htmlFor="file-upload" className="absolute bottom-[15px] flex justify-center w-full">
                                                                            <div className="p-image rounded-full relative cursor-pointer">
                                                                                <i className="fi-rr-camera text-[#fff] text-sm leading-[17px]"></i>
                                                                            </div>
                                                                        </label>
                                                                        <input
                                                                            id="file-upload"
                                                                            className="file-upload hidden"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            name="profileImg"
                                                                            onChange={(e) => handle_astro_register_form(e, "profileImg")}
                                                                        />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="gi-login-wrap flex gi-register-half w-[50%] flex-col pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                    Full Name</label>
                                                                <div className="iconflex">
                                                                    <i className="fi-rr-user text-gray-700 text-[13px] leading-[17px]"></i>
                                                                    <input type="text" name="name" placeholder="Enter your name" value={astro_register_form?.name} onChange={handle_astro_register_form}
                                                                        className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                        required />
                                                                </div>
                                                            </div>
                                                            <div className="gi-login-wrap flex gi-register-half w-[50%] flex-col pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                    User Name</label>
                                                                <div className="iconflex">
                                                                    <i className="fi-rr-user text-gray-700 text-[13px] leading-[17px]"></i>
                                                                    <input type="text" name="user_name" placeholder="Enter your Username" value={astro_register_form?.user_name} onChange={handle_astro_register_form}
                                                                        className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                        required />
                                                                </div>
                                                            </div>
                                                            <div className="gi-login-wrap flex gi-register-half w-[50%] flex-col pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                    Email ID</label>
                                                                <div className="iconflex">
                                                                    <i className="fi-rs-envelope text-gray-700 text-[13px] leading-[17px]"></i>
                                                                    <input type="email" name="email" placeholder="Email ID" value={astro_register_form?.email} onChange={handle_astro_register_form}
                                                                        className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                        required />
                                                                </div>
                                                            </div>
                                                            <div className="gi-login-wrap flex flex-col mb-3 gi-register-half w-[50%] pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">Phone
                                                                    Number</label>
                                                                <PhoneInput
                                                                    international
                                                                    value={phoneNumber}
                                                                    defaultCountry={countryCode}
                                                                    onChange={handlePhoneChange}
                                                                    onKeyDown={handleKeyDown}
                                                                    maxLength={15}
                                                                    className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                    placeholder="Enter phone number"
                                                                />
                                                                {!isValid && <span className="text-red-500 text-[13px]">Please enter a valid phone number</span>}
                                                            </div>
                                                            <div className="gi-login-wrap flex gi-register-half w-[50%] flex-col pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                    Date Of Birth</label>
                                                                <div className="iconflex">
                                                                    <i className="fi-rs-calendar text-gray-700 text-[13px] leading-[17px]"></i>

                                                                    <input type="date" name="dob" placeholder="date" max={new Date().toISOString().split("T")[0]} onChange={handle_astro_register_form} value={astro_register_form?.dob || ""}
                                                                        className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] 
                                                        rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                        required />
                                                                </div>
                                                            </div>
                                                            <div className="gi-login-wrap flex flex-col mb-3 gi-register-half w-[50%] pr-3">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">Gender</label>
                                                                <div className="grid w-full gap-3 md:grid-cols-3">
                                                                    <div className="relative">
                                                                        <input type="radio" id="male" value="male"
                                                                            checked={astro_register_form?.gender == "male"}
                                                                            name="gender"
                                                                            onChange={handle_astro_register_form}
                                                                            className="absolute bottom-[18px] left-[15px] peer" />
                                                                        <label for="male"
                                                                            className="m-0 pl-[30px] inline-flex items-center justify-start w-full p-2 h-[45px] font-medium text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 light:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-700 dark:hover:bg-gray-700">
                                                                            <div className="block pr-2">
                                                                                <div className="w-full">Male</div>
                                                                            </div>
                                                                        </label>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <input type="radio" id="female" value="female"
                                                                            checked={astro_register_form?.gender == "female"}
                                                                            name="gender"
                                                                            onChange={handle_astro_register_form}
                                                                            className="absolute bottom-[18px] left-[15px] peer" />
                                                                        <label for="female"
                                                                            className="m-0 pl-[30px] inline-flex items-center justify-start w-full p-2 h-[45px] font-medium text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 light:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-700 dark:hover:bg-gray-700">
                                                                            <div className="block pr-2">
                                                                                <div className="w-full">Female</div>
                                                                            </div>

                                                                        </label>
                                                                    </div>
                                                                    <div className="relative">
                                                                        <input type="radio" id="other" value="other"
                                                                            checked={astro_register_form?.gender == "other"}
                                                                            name="gender"
                                                                            onChange={handle_astro_register_form}
                                                                            className="absolute bottom-[18px] left-[15px] peer" />
                                                                        <label for="other"
                                                                            className="m-0 pl-[30px] inline-flex items-center justify-start w-full p-2 h-[45px] font-medium text-gray-500 bg-white border rounded-lg cursor-pointer dark:hover:text-gray-300 light:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-700 dark:hover:bg-gray-700">
                                                                            <div className="block pr-2">
                                                                                <div className="w-full">Other</div>
                                                                            </div>

                                                                        </label>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                <label
                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                    Role</label>
                                                                <Select
                                                                    options={user_Roles}
                                                                    isSearchable={false}

                                                                    name="role"
                                                                    value={user_Roles.find(role => role.value === astro_register_form.role)}
                                                                    onChange={handleRoleChange}
                                                                    placeholder="Select Roles"
                                                                    className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                    styles={{
                                                                        control: (base, state) => ({
                                                                            ...base,
                                                                            border: "none",
                                                                            boxShadow: state.isFocused ? "none" : "none"
                                                                        })
                                                                    }}
                                                                />
                                                            </div>
                                                            {/* <div className="gi-login-wrap flex flex-col mb-3 gi-register-half w-[50%] pr-3">
                                                    <label
                                                        className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">Role</label>
                                                    <div className="grid w-full gap-3 md:grid-cols-3">
                                                        <div className="relative">
                                                            <input type="radio" id="astrologer" value="2"
                                                                checked={astro_register_form?.role == "2"}
                                                                name="role"
                                                                onChange={handle_astro_register_form}
                                                                className="absolute bottom-[18px] left-[15px] peer" />
                                                            <label for="astrologer"
                                                                className="m-0 pl-[30px] inline-flex items-center justify-start w-full p-2 h-[45px] font-medium text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 light:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-700 dark:hover:bg-gray-700">
                                                                <div className="block pr-2">
                                                                    <div className="w-full">Astrologer</div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div className="relative">
                                                            <input type="radio" id="pandit" value="3"
                                                                checked={astro_register_form?.role == "3"}
                                                                name="role"
                                                                onChange={handle_astro_register_form}
                                                                className="absolute bottom-[18px] left-[15px] peer" />
                                                            <label for="pandit"
                                                                className="m-0 pl-[30px] inline-flex items-center justify-start w-full p-2 h-[45px] font-medium text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 light:border-gray-700 dark:peer-checked:text-blue-500 peer-checked:border-blue-600 peer-checked:text-blue-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-700 dark:hover:bg-gray-700">
                                                                <div className="block pr-2">
                                                                    <div className="w-full">Pandit</div>
                                                                </div>

                                                            </label>
                                                        </div>
                                                      
                                                    </div>


                                                </div> */}
                                                            {astro_register_form?.role && (
                                                                <>
                                                                    <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                        <label
                                                                            className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1]">
                                                                            Experience (in years)</label>
                                                                        <div className="iconflex">
                                                                            <i className="fi-rr-user text-gray-700 text-[13px] leading-[17px]"></i>
                                                                            <input type="number" min="0" max="50" name="experience" placeholder="Enter your experience" value={astro_register_form?.experience} onChange={handle_astro_register_form}
                                                                                className="w-full mb-[15px] px-[12px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-gray-700 text-[13px] outline-[0] h-[45px] font-medium"
                                                                                required />
                                                                        </div>
                                                                    </div>
                                                                    {astro_register_form?.role === "2" && (
                                                                        <>
                                                                            {/* astro_languages */}
                                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                                <label
                                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1] p-1">
                                                                                    Languages</label>
                                                                                <Select
                                                                                    options={astrologer_language} // Make sure options is an array of { value, label } objects
                                                                                    isMulti
                                                                                    name="language"
                                                                                    value={astro_register_form.language} // Directly use the array
                                                                                    onChange={(selected) => handle_astro_register_form(selected, "language")} // Pass selected options to handler
                                                                                    placeholder="Select options..."
                                                                                    className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                                    classNamePrefix="react-select"
                                                                                    styles={{
                                                                                        control: (base, state) => ({
                                                                                            ...base,
                                                                                            border: "none",
                                                                                            boxShadow: state.isFocused ? "none" : "none",
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    {astro_register_form?.role === "3" && (
                                                                        <>
                                                                            {/* pandit_languages */}
                                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                                <label
                                                                                    className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1] p-1">
                                                                                    Languages</label>
                                                                                <Select
                                                                                    options={pandit_language} // Make sure options is an array of { value, label } objects
                                                                                    isMulti
                                                                                    name="language"
                                                                                    value={astro_register_form.language} // Directly use the array
                                                                                    onChange={(selected) => handle_astro_register_form(selected, "language")} // Pass selected options to handler
                                                                                    placeholder="Select options..."
                                                                                    className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                                    classNamePrefix="react-select"
                                                                                    styles={{
                                                                                        control: (base, state) => ({
                                                                                            ...base,
                                                                                            border: "none",
                                                                                            boxShadow: state.isFocused ? "none" : "none",
                                                                                        }),
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {astro_register_form?.role === "2" && (
                                                                        <>
                                                                            {/* astrologer_skills */}
                                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                                <label className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1] p-1">
                                                                                    Skills</label>
                                                                                <div className="iconflex">
                                                                                    <img src={Common_Images_Transport?.skills_icon} alt="" />
                                                                                    <Select
                                                                                        options={astrologer_skills}  // Dynamically populated options
                                                                                        isMulti
                                                                                        name="skills"
                                                                                        value={astro_register_form.skills} // Ensure it's an array of objects { value, label }
                                                                                        onChange={(selected) => handle_astro_register_form(selected, "skills")}
                                                                                        placeholder="Select options..."
                                                                                        className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                                        classNamePrefix="react-select"
                                                                                        styles={{
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                border: "none",
                                                                                                boxShadow: state.isFocused ? "none" : "none",
                                                                                            }),
                                                                                        }}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                    }
                                                                    {astro_register_form?.role === "3" && (
                                                                        <>
                                                                            {/* pandit_skills */}

                                                                            <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                                <label className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1] p-1">
                                                                                    Skills</label>
                                                                                <div className="iconflex">
                                                                                    <img src={Common_Images_Transport?.skills_icon} alt="" />
                                                                                    <Select
                                                                                        options={pandit_skills}  // Dynamically populated options
                                                                                        isMulti
                                                                                        name="skills"
                                                                                        value={astro_register_form.skills} // Ensure it's an array of objects { value, label }
                                                                                        onChange={(selected) => handle_astro_register_form(selected, "skills")}
                                                                                        placeholder="Select options..."
                                                                                        className="react-select-container mb-[15px] text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                                        classNamePrefix="react-select"
                                                                                        styles={{
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                border: "none",
                                                                                                boxShadow: state.isFocused ? "none" : "none",
                                                                                            }),
                                                                                        }}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    {astro_register_form?.role === "3" && (
                                                                        <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                                                            <label className="mb-[10px] text-gray-700 text-[13px} font-medium tracking-[0] leading-[1] p-1">
                                                                                Pooja Category</label>
                                                                            <div className="iconflex">
                                                                                {/* <img src={Common_Images_Transport?.skills_icon} alt="" /> */}
                                                                                <Select
                                                                                    options={pooja_Categories}  // Original data
                                                                                    isMulti
                                                                                    name="poojacategorie"
                                                                                    value={astro_register_form.poojacategorie}  // Also raw data
                                                                                    onChange={(selected) =>
                                                                                        handle_astro_register_form(selected, "poojacategorie")
                                                                                    }
                                                                                    getOptionLabel={(option) => option.title}   // Show title
                                                                                    getOptionValue={(option) => option.id}      // Unique ID
                                                                                    placeholder="Select options..."
                                                                                    className="react-select-container text-[12px] font-medium p-1 text-gray-700 bg-white border rounded-lg"
                                                                                    classNamePrefix="react-select"
                                                                                    styles={{
                                                                                        control: (base, state) => ({
                                                                                            ...base,
                                                                                            border: "none",
                                                                                            boxShadow: state.isFocused ? "none" : "none",
                                                                                        }),
                                                                                    }}
                                                                                />

                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}


                                                            <div className="flex mt-3 justify-between gi-register-half w-[100%]">
                                                                <div className="flex items-start">
                                                                    <div className="flex items-center h-5">

                                                                        <input
                                                                            id="remember"
                                                                            type="checkbox"
                                                                            className="bg-gray-50 border border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                                                                            required
                                                                            checked={checkboxChecked}
                                                                            onChange={handleCheckboxChange}
                                                                        />
                                                                    </div>
                                                                    <div className="text-sm ml-3">
                                                                        <label
                                                                            htmlFor="remember"
                                                                            className="text-gray-900 text-[12px] font-medium dark:text-gray-500"
                                                                        >
                                                                            I agree to Terms & Conditions and Privacy Policy
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="gi-login-wrap gi-register-half w-[100%]">
                                                                <button type="submit"
                                                                    className="w-full uppercase  mt-[20px] block text-center text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500] rounded-[5px] text-[16px] outline-[0] h-[45px] font-medium">Submit</button>
                                                            </div>

                                                            <span className="gi-login-wrap gi-login-btn mt-[20px] flex flex-row justify-center gap-3 items-center">
                                                                <span className="text-gray-700 text-[13px]">
                                                                    If you have an account with us, please log in.
                                                                </span>
                                                                <Link
                                                                    to="/astrologer-login"
                                                                    className="gi-btn-1 btn py-[8px] px-[12px] text-[#9F2225] border-[0] transition-all duration-[0.3s] ease-in-out overflow-hidden text-center text-[13px] font-semibold relative rounded-[5px] hover:text-[#333]"
                                                                >
                                                                    Login Account
                                                                </Link>
                                                            </span>
                                                        </form>
                                                    </div>
                                                ) : (
                                                    <div className="text-center w-full">
                                                        <h2 className="gi-title mb-[0] font-Poppins text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">
                                                            Verification code
                                                        </h2>
                                                        <p className="mt-[15px] text-[14px] text-[#777] leading-[23px] mb-[20px]">
                                                            We have sent the verification code on your mobile number
                                                            <span className="font-bold text-black"> +{formatMobileNumber(mobileNumber)}</span>
                                                        </p>
                                                        <form action="#" method="post" className="flex flex-col" onSubmit={Handle_Astrologer_Register_Otp_Verify}>
                                                            <div className="gi-login-wrap flex-col">
                                                                <div className="otp-input-fields w-full flex justify-center gap-[10px] mb-[20px]">
                                                                    <OtpInput
                                                                        value={otp}
                                                                        onChange={(newOtp) => {
                                                                            if (/^\d*$/.test(newOtp)) {
                                                                                setOtp(newOtp);
                                                                                if (newOtp.length === 4) {
                                                                                    setOtpError(false);
                                                                                }
                                                                            }
                                                                        }}
                                                                        numInputs={4}
                                                                        shouldAutoFocus
                                                                        renderInput={(props) => (
                                                                            <input
                                                                                {...props}
                                                                                type="number"
                                                                                className="otp__digit otp__field__1 rounded-[50%] border-[1px] border-[#ddd] p-[0] 
                                                                                text-center text-[16px] text-[#333] focus:outline-none"
                                                                            />
                                                                        )}
                                                                    />
                                                                </div>
                                                                {otpError && <span className="text-red-500 text-sm">Please enter a valid OTP.</span>}
                                                            </div>
                                                            <div className="text-center mb-[15px]">
                                                                {cooldownTime > 0 ? (
                                                                    <span className="text-[14px] text-red-500 font-medium">
                                                                        Too many attempts. Try again in {formatTimer(cooldownTime)}
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-[14px] text-[#777]">
                                                                        {otpTimer > 0 ? `Resend OTP in ${formatTimer(otpTimer)}` : ""}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={HandleResendOtp}
                                                                disabled={otpTimer > 0 || cooldownTime > 0}
                                                                className={`w-full mb-[10px] block p-[14px] text-center rounded-[5px] text-[16px] outline-[0] h-[50px] ${otpTimer > 0 || cooldownTime > 0
                                                                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                                    : "text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                                    }`}
                                                            >
                                                                Resend OTP
                                                            </button>
                                                            <button
                                                                type="submit"
                                                                disabled={cooldownTime > 0}
                                                                className={`w-full mt-[20px] block p-[14px] text-center text-[#fff] rounded-[5px] text-[16px] outline-[0] h-[50px] ${cooldownTime > 0
                                                                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                                    : "bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                                    }`}
                                                            >
                                                                Submit
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={() => setShowOtpScreen(false)}
                                                                className="w-full mt-[10px] block p-[14px] text-center text-[#9F2225] bg-transparent border border-[#9F2225] rounded-[5px] text-[16px] outline-[0] h-[50px]"
                                                            >
                                                                Back to Register
                                                            </button>
                                                        </form>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                        </>
                    )
                }

                {/* <---------- Footer section's ---------> */}
                <Footer />
            </div>
        </>
    )
}

export default Astrologer_Register